import { pascalizeKeys } from 'humps';

class TemplateAPI {
  constructor(iframe) {
    this.iframe = iframe;
  }

  getConstellation() {
    return new Promise((resolve) => {
      this.interval = setInterval(() => {
        const { constellation } = this.iframe.contentWindow;
        if (constellation) {
          clearInterval(this.interval);
          resolve(constellation);
        }
      }, 100);
    });
  }

  async updateFeed(feed) {
    const constellation = await this.getConstellation();
    const { hub } = constellation;
    hub.send({
      type: 'inject-data',
      rows: pascalizeKeys(feed),
      sender: {
        name: 'PuppetMaster',
      },
      mode: 'event',
    });
  }

  destroy() {
    clearInterval(this.interval);
  }
}

export default TemplateAPI;



// WEBPACK FOOTER //
// ./src/templates/display/data/iframe-template-api.js